import Vue from 'vue';
import Router from 'vue-router';
import routes from './constants/routes';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { top: 0 };
  },
});

export default router;
